<template>
  <lazy-div :title="title" :breadcrumb="breadcrumb">
    <v-card>
      <form data-vv-scope="privilegesGrpForm">
        <v-card-title>
          <div>
            <div class="headline">Summary</div>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-title>
          <div class="body-2">{{ labels.general }}</div>
        </v-card-title>
        <v-card-text>
          <message :messages="messages" v-if="!privilegeDialog"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="!newPrivilegesGrp">
                <v-subheader class="queryLabel">{{ labels.privilegeGrpId }}</v-subheader>
                <div class="subheading">{{ privilegesGrpForm.privilegeGrpId }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newPrivilegesGrp">
                <v-text-field
                  :label="labels.description"
                  v-model="privilegesGrpForm.description"
                  :error-messages="errors.collect('privilegesGrpForm.description')"
                  v-validate="'required|entry|max:255'"
                  data-vv-name="description"
                  :data-vv-as="labels.description"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-else>
                <v-text-field
                  :label="labels.description"
                  v-model="privilegesGrpForm.description"
                  :error-messages="errors.collect('privilegesGrpForm.description')"
                  v-validate="'required|entry|max:255'"
                  data-vv-name="description"
                  :data-vv-as="labels.description"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="params.privilegeGrpList"
                  v-model="privilegesGrpForm.parentId"
                  :label="labels.parentId"
                  item-text="label"
                  item-value="value"
                  data-vv-name="parentId"
                  :data-vv-as="labels.parentId"
                  :error-messages="errors.collect('parentId')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.seq"
                  v-model="privilegesGrpForm.seq"
                  :error-messages="errors.collect('privilegesGrpForm.seq')"
                  v-validate="'required|integer|max:10'"
                  data-vv-name="seq"
                  :data-vv-as="labels.seq"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-btn color="primary" type="submit" @click.prevent="doSaveGeneral">
          {{ newPrivilegesGrp ? 'Save Privilege Group' : 'Update Privilege Group' }}
          <v-icon right>{{ newPrivilegesGrp ? 'mdi-plus' : 'mdi-content-save' }}</v-icon>
        </v-btn>
        <v-divider></v-divider>
      </form>
      <v-divider></v-divider>
      <form v-if="!newPrivilegesGrp">
        <v-card-title>
          <div>
            <div class="headline">{{ labels.privilegeList }}</div>
          </div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table
          v-bind:headers="headers"
          v-bind:items="items"
          v-bind:search="search"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          v-bind:options.sync="pagination"
          item-key="privilegeId"
          :loading="loading"
          :custom-filter="customSearch"
        >
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span v-on="on">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:item="row">
            <tr>
              <td class="text-xs-left">{{ row.item.privilegeId }}</td>
              <td class="text-xs-left">{{ row.item.description }}</td>
              <td class="text-xs-left">{{ row.item.additionalInfo }}</td>
              <td class="text-xs-left">{{ row.item.seq }}</td>
              <td class="table-action-header">
                <table-action :rowData="row" review @review="doReview" @remove="doPromptRemove(row.item)"></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-btn v-on="on" color="primary" dark class="mb-2" @click="doNew">Add Privilege<v-icon right>mdi-plus</v-icon></v-btn>
        <v-dialog v-model="privilegeDialog" max-width="500px" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">{{ labels.privilegeFormTitle }}</span>
            </v-card-title>
            <v-card-text>
              <message :messages="messages"></message>
              <form data-vv-scope="privilegeValForm">
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs6 v-if="newPrivilege">
                      <v-text-field
                        data-vv-scope="privilegeValForm"
                        v-model="privilegeForm.privilegeId"
                        :label="labels.privilegeId"
                        :error-messages="errors.collect('privilegeValForm.privilegeId')"
                        data-vv-name="privilegeId"
                        :data-vv-as="labels.privilegeId"
                        v-validate="'required|param|max:25'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 v-else>
                      <v-subheader class="queryLabel">{{ labels.privilegeId }}</v-subheader>
                      <div class="subheading">{{ privilegeForm.privilegeId }}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        data-vv-scope="privilegeValForm"
                        v-model="privilegeForm.seq"
                        :label="labels.privilegeSeq"
                        :error-messages="errors.collect('privilegeValForm.seq')"
                        v-validate="'required|integer|max:10'"
                        data-vv-name="seq"
                        :data-vv-as="labels.privilegeSeq"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        data-vv-scope="privilegeValForm"
                        v-model="privilegeForm.description"
                        :label="labels.privilegeDesc"
                        :error-messages="errors.collect('privilegeValForm.description')"
                        v-validate="'required|entry|max:255'"
                        data-vv-name="description"
                        :data-vv-as="labels.privilegeDesc"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        data-vv-scope="privilegeValForm"
                        v-model="privilegeForm.additionalInfo"
                        :label="labels.additionalInfo"
                        :error-messages="errors.collect('privilegeValForm.additionalInfo')"
                        v-validate="'entry|max:255'"
                        data-vv-name="additionalInfo"
                        :data-vv-as="labels.additionalInfo"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click.native="dialogPrivilegeClose">Cancel</v-btn>
              <v-btn color="primary" text @click.native="privilegeSave">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <confirm v-model="promptRemove" @ok="doRemove">
          Are you sure that you want to delete the selected Privilege? ({{ deleteUserPrivilege }})
        </confirm>
      </form>
    </v-card>
  </lazy-div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'

export default {
  props: ['id'],
  data() {
    return {
      breadcrumb: [],
      headers: [
        { text: 'Privilege ID', value: 'privilegeId' },
        { text: 'Privilege Description', value: 'privilegeDesc' },
        { text: 'Additional Information', value: 'additionalInfo' },
        { text: 'Sequence', value: 'privilegeSeq' },
        TableConst.tableActionHeader
      ],
      labels: {
        general: 'Privilege Group Details',
        privilegeList: 'Privileges List',
        privilegeFormTitle: 'Privilege Details',

        privilegeGrpId: 'Privilege Group ID',
        description: 'Privilege Group Description*',
        parentId: 'Parent ID*',
        seq: 'Sequence*',
        privilegeId: 'Privilege ID*',
        privilegeDesc: 'Privilege Description*',
        additionalInfo: 'Additional Information',
        privilegeSeq: 'Sequence*'
      },
      privilegeIndex: -1,
      privilegeForm: {
        privilegeGrpId: null,
        privilegeId: null,
        description: null,
        additionalInfo: null,
        seq: null
      },
      privilegesGrpForm: {
        privilegeGrpId: null,
        description: null,
        parentId: null,
        seq: null
      },
      params: {
        privilegeGrpList: []
      },
      defaultItems: [],
      newPrivilege: undefined,
      newPrivilegesGrp: null,
      privilegeDialog: undefined,
      PrivilegesGrpIdList: null,
      promptRemove: false,
      selectedPrivilege: undefined,
      deleteUserPrivilege: ''
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    title() {
      if (this.newPrivilegesGrp) {
        return 'New Privilege Group'
      } else {
        return 'Review Privilege'
      }
    },
    privilege() {
      return this.$store.state.adminUser.privilege
    }
  },
  methods: {
    async privilegesGrpFormInit() {
      const apiURI = this.privilege.menu.userPrivilegesGrp
      if (apiURI) {
        try {
          const expand = {
            privilegeGrpId: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.privilegesGrpForm.privilegeGrpId = data.privilegeGrp.privilegeGrpId
            this.privilegesGrpForm.description = data.privilegeGrp.description
            this.privilegesGrpForm.parentId = data.privilegeGrp.parentId
            this.privilegesGrpForm.seq = data.privilegeGrp.seq
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doInit() {
      this.loading = true
      const apiURI = this.privilege.menu.userPrivileges
      if (apiURI) {
        try {
          const expand = {
            privilegeGrp: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((privilege) => {
              const convertPrivilege = {
                privilegeId: privilege.privilegeId,
                description: privilege.description,
                additionalInfo: privilege.additionalInfo,
                seq: privilege.seq
              }
              this.items.push(convertPrivilege)
            })
            this.cloneItems(this.items)
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    cloneItems(items) {
      this.defaultItems = JSON.parse(JSON.stringify(items))
    },
    async privilegeGrpList() {
      const apiURI = this.privilege.menu.privilegeGrpList
      if (apiURI) {
        try {
          if (this.id === 'new') {
            this.PrivilegesGrpIdList = 0
          } else {
            this.PrivilegesGrpIdList = this.id
          }

          const expand = {
            privilegeGrpId: this.PrivilegesGrpIdList
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.$set(this.params, 'privilegeGrpList', result.data.data.privilegeGrpList)
            this.loading = false
          } else {
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    doReview(data) {
      this.newPrivilege = false
      this.privilegeDialog = true
      this.privilegeIndex = data.index
      this.privilegeForm.privilegeId = data.item.privilegeId
      this.privilegeForm.description = data.item.description
      this.privilegeForm.additionalInfo = data.item.additionalInfo
      this.privilegeForm.seq = data.item.seq
    },
    dialogPrivilegeClose() {
      this.privilegeDialog = false
      this.privilegeForm.privilegeId = null
      this.privilegeForm.description = null
      this.privilegeForm.additionalInfo = null
      this.privilegeForm.seq = null
      this.resetValidator()
      this.resetMessages()
    },
    doNew() {
      this.newPrivilege = true
      this.privilegeDialog = true
    },
    async doSaveGeneral() {
      this.resetMessages()
      this.$validator.validateAll('privilegesGrpForm').then((result) => {
        if (result) {
          if (this.newPrivilegesGrp) {
            this.doCreatePrivilegesGrp()
          } else {
            this.doUpdatePrivilegesGrp()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    privilegeSave() {
      this.resetMessages()
      this.$validator.validateAll('privilegeValForm').then((result) => {
        if (result) {
          if (this.newPrivilege) {
            this.doCreatePrivilege()
          } else {
            this.doUpdatePrivilege()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPrivilege = data
        this.deleteUserPrivilege = data.privilegeId + ' - ' + data.description
      }
    },
    async doRemove() {
      const apiURI = this.privilege.menu.deleteUserPrivilege
      if (apiURI) {
        this.loading = true
        const expand = {
          privilegeId: this.selectedPrivilege.privilegeId
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    resetForm() {
      this.privilegeForm.privilegeId = undefined
      this.privilegeForm.description = undefined
      this.privilegeForm.additionalInfo = undefined
      this.privilegeForm.seq = undefined
    },
    async doCreatePrivilege() {
      const apiURI = this.privilege.menu.userPrivilegesCreate
      if (apiURI) {
        this.submitting = true
        try {
          const resultPrivilegeForm = {
            privilegeId: this.privilegeForm.privilegeId,
            description: this.privilegeForm.description,
            additionalInfo: this.privilegeForm.additionalInfo,
            seq: this.privilegeForm.seq,
            privilegeGrpId: this.id
          }
          const result = this.$http.post(apiURI, resultPrivilegeForm)
          const { data } = await result
          if (data) {
            this.notify(data)
            this.doInit()
            this.dialogPrivilegeClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdatePrivilege() {
      const apiURI = this.privilege.menu.userPrivilegesUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const resultPrivilegeForm = {
            privilegeId: this.privilegeForm.privilegeId,
            description: this.privilegeForm.description,
            additionalInfo: this.privilegeForm.additionalInfo,
            seq: this.privilegeForm.seq,
            privilegeGrpId: this.id
          }
          const result = this.$http.put(apiURI, resultPrivilegeForm)
          const { data } = await result
          if (data) {
            this.notify(data)
            this.doInit()
            this.dialogPrivilegeClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doCreatePrivilegesGrp() {
      const apiURI = this.privilege.menu.userPrivilegesGrpCreate
      if (apiURI) {
        this.submitting = true
        try {
          const resultPrivilegeGrpForm = {
            description: this.privilegesGrpForm.description.trim(),
            parentId: this.privilegesGrpForm.parentId,
            seq: this.privilegesGrpForm.seq
          }
          const result = await this.$http.post(apiURI, resultPrivilegeGrpForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          await this.$store.dispatch('privilegeInit')
          this.submitting = false
          this.$router.push({ name: 'privileges' })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdatePrivilegesGrp() {
      const apiURI = this.privilege.menu.userPrivilegesGrpUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const resultPrivilegeGrpForm = {
            privilegeGrpId: this.privilegesGrpForm.privilegeGrpId,
            description: this.privilegesGrpForm.description.trim(),
            parentId: this.privilegesGrpForm.parentId,
            seq: this.privilegesGrpForm.seq
          }
          const result = await this.$http.put(apiURI, resultPrivilegeGrpForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    }
  },
  mounted() {
    this.breadcrumb = this.derieveBreadcrumbByName('privileges')
    this.breadcrumb.push({
      name: 'privilegesReview',
      text: this.title
    })
    if (this.id === 'new') {
      this.loading = false
      this.newPrivilegesGrp = true
    }
  },
  created() {
    if (this.id === 'new') {
      this.newPrivilegesGrp = true
      this.privilegeGrpList()
    } else {
      Promise.all([this.privilegeGrpList(), this.privilegesGrpFormInit(), this.doInit()])
    }
  },
  mixins: [TableConst.default, MessageMixin, FieldMixin]
}
</script>

<style>
</style>
